import { useEffect, useRef } from 'react';
import { useScrollGroupContext } from './context.mjs';
import { useScrollGroupSetScroll } from './useScrollGroupSetScroll.mjs';
"use strict";
function useScrollGroupItem(item) {
  const {
    registerItem,
    scrollGroupItemsRef,
    currentManualScrollMetaRef,
    onScrollItem,
    onAddItem,
    onResizeItem
  } = useScrollGroupContext();
  useEffect(() => {
    const unregisterItem = registerItem(item);
    return () => {
      unregisterItem();
    };
  }, [item, registerItem]);
  useEffect(() => {
    const element = item.refObject.current;
    if (!element) return;
    const handler = event => {
      onScrollItem?.(element, event);
    };
    element.addEventListener("scroll", handler);
    return () => {
      element.removeEventListener("scroll", handler);
    };
  }, [item, item.refObject, onScrollItem]);
  const onAddItemRef = useRef(onAddItem);
  useEffect(() => {
    onAddItemRef.current = onAddItem;
  }, [onAddItem]);
  useEffect(() => {
    const element = item.refObject.current;
    if (element) {
      onAddItemRef.current?.(element);
    }
    return void 0;
  }, [item, item.refObject, onAddItem]);
  useEffect(() => {
    const element = item.refObject.current;
    if (!element) {
      return void 0;
    }
    const handler = () => {
      onResizeItem?.(element);
    };
    window.addEventListener("resize", handler);
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, [item.refObject, onResizeItem]);
  const scrollAllTo = useScrollGroupSetScroll();
  useEffect(() => {
    const thisElement = item.refObject.current;
    if (!thisElement) {
      return;
    }
    const handler = () => {
      if (!scrollGroupItemsRef.current) {
        return;
      }
      if (!currentManualScrollMetaRef.current) {
        scrollAllTo({
          top: thisElement.scrollTop,
          left: thisElement.scrollLeft
        });
      }
    };
    thisElement.addEventListener("scroll", handler);
    return () => {
      thisElement.removeEventListener("scroll", handler);
    };
  }, [currentManualScrollMetaRef, item.refObject, scrollAllTo, scrollGroupItemsRef]);
}
export { useScrollGroupItem };
//# sourceMappingURL=useScrollGroupItem.mjs.map
